import { Button, Card, Popconfirm } from "antd";
import { useDispatch } from "react-redux";
import {
  deleteResponsable,
  updateSaveResponsable,
} from "../ResponsablesSlice/Responsables.slice";
import CustomForm from "../../../components/CustomForm";
import React, { useRef, useState } from "react";
import { userHasLevel } from "../../../../engine/AuthRoute";
import routes from "../../../../engine/routes";
import { modalApplicantIntervenantInputs } from "../../../components/CreateApplicant/ModalApplicantIntervenantInputs";
import { renderResponsable } from "../../../../utils/constants";
import { useTranslation } from "react-i18next";

export const ResponsableItem = ({
  responsable,
  defaultId = null,
  isChecked,
  institution,
  principal,
  isNew = false,
}) => {
  const { _id } = responsable;

  const formRef = useRef(null);

  const dispatch = useDispatch();
  const [isEdit, setIsEdit] = useState(false);

  const { t } = useTranslation(); // Translation hook

  const deleteItem = () => {
    dispatch(deleteResponsable(responsable));
  };

  const {
    principal: principalAdress,
    institution: institutionAdress,
    email,
    lastname,
    firstname,
    phone,
    role,
  } = responsable;

  const handleSubmit = data => {
    data._id = responsable._id;
    const update = dispatch(updateSaveResponsable(data));
  };

  const changeEdition = () => {
    setIsEdit(!isEdit);
  };

  const userCanUpdate = userHasLevel(routes.institutions().responsables, "u");

  const userCanChangeAddress = () => {
    return !userCanUpdate;
  };

  const renderText = () => {
    return (
      <strong>
        {phone}
        <br />
        {email}
      </strong>
    );
  };

  return (
    <>
      <Card
        key={_id}
        title={<>{renderResponsable(responsable)}</>}
        extra={[
          <Button
            disabled={userCanChangeAddress()}
            onClick={changeEdition}
            size={"small"}
            type={"primary"}
            style={{ marginRight: 10 }}
          >
            {isEdit ? t("ResponsableItem.cancel") : t("ResponsableItem.edit")}
          </Button>,
          <Popconfirm
            disabled={!isEdit && userCanChangeAddress()}
            title={t("ResponsableItem.deleteTitle")}
            description={t("ResponsableItem.deleteDescription")}
            onConfirm={deleteItem}
            onCancel={() => {}}
            okText={t("ResponsableItem.yes")}
            cancelText={t("ResponsableItem.no")}
          >
            <Button
              disabled={!isEdit && userCanChangeAddress()}
              size={"small"}
              type={"primary"}
            >
              {t("ResponsableItem.delete")}
            </Button>
          </Popconfirm>,
        ]}
      >
        {isEdit ? (
          <CustomForm
            refForm={formRef}
            disabled={!userCanUpdate}
            dataSource={modalApplicantIntervenantInputs({
              setOpen: changeEdition,
              name: "intervenant",
              update: true,
              values: responsable,
            })}
            labelCol={24}
            wrapperCol={24}
            handleSubmit={handleSubmit}
          />
        ) : (
          renderText()
        )}
      </Card>
    </>
  );
};
